/* Ambient product videos (native uploads): play immediately as muted loops
   with no chrome. Controls appear on hover — or on tap where hover doesn't
   exist — and hide again on leave. Videos pause while offscreen.
   prefers-reduced-motion gets a paused video with controls always visible.
   Rendered by snippets/product-thumbnail.liquid. */
if (!customElements.get('ambient-video')) {
  customElements.define(
    'ambient-video',
    class AmbientVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        // Browsers only allow autoplay when muted; set as properties too,
        // since some engines ignore the attributes alone.
        this.video.muted = true;
        this.video.setAttribute('playsinline', '');
        this.video.loop = true;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.removeAttribute('autoplay');
          this.video.controls = true;
          this.video.pause();
          return;
        }

        if (window.matchMedia('(hover: hover)').matches) {
          this.addEventListener('mouseenter', () => (this.video.controls = true));
          this.addEventListener('mouseleave', () => (this.video.controls = false));
        } else {
          this.video.addEventListener(
            'click',
            () => (this.video.controls = true),
            { once: true }
          );
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return this.video.pause();
              const played = this.video.play();
              if (played) played.catch(() => {});
            });
          },
          { threshold: 0.25 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
